export interface UserNameLike {
  first_name?: string | null;
  last_name?: string | null;
}

function hasFullUserName(user?: UserNameLike | null): boolean {
  return Boolean(user?.first_name && user?.last_name);
}

function getFullUserName(user?: UserNameLike | null): string | undefined {
  if (!hasFullUserName(user)) return undefined;

  return `${user?.first_name} ${user?.last_name}`;
}

export { getFullUserName, hasFullUserName };
